var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasBtn)?_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.goBinding()}}},[_vm._v("用户绑定")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }